import { Checkbox } from "@atoms/index"

import { CheckboxCardProps } from "./CheckboxCard.types"

export default function CheckboxCard(props: CheckboxCardProps) {
    return <Checkbox {...props} variant="card" />
}
